import { motion } from 'framer-motion';

/*
 * PLACEHOLDER CONTENT — needs real quotes from physician users before launch.
 *
 * For each testimonial, the team needs to provide:
 *   - quote: 1–3 sentences in the physician's own words
 *   - name: full name (e.g. "Dr. Sarah Chen")
 *   - title: specialty + clinic (e.g. "Family Physician, Ancaster Medical Centre")
 *   - city: city, province (e.g. "Hamilton, ON")
 *   - initials: 2-letter initials for the avatar (e.g. "SC")
 *   - accentColor: optional — leave blank to use default blue
 *
 * Suggested ask: email 3–5 current users (partner clinics) for a quote.
 * Target: at least 2 real testimonials before this section goes live.
 * Until then, this section is commented out of App.js.
 */

const testimonials = [
  {
    quote: '"Quotes from our Ontario clinic partners are on the way. We\'re asking physicians to share their experience in their own words."',
    name: 'Family Physician',
    title: 'Ontario clinic partner',
    city: 'Ontario',
    initials: 'FP',
    placeholder: true,
  },
  {
    quote: '"More stories coming soon from pediatricians, internists, and clinic staff across the province."',
    name: 'Pediatrician',
    title: 'Ontario clinic partner',
    city: 'Ontario',
    initials: 'MD',
    placeholder: true,
  },
  {
    quote: '"Real outcomes, in physicians\' own words — publishing as our clinic partners share their results."',
    name: 'Clinic Administrator',
    title: 'Ontario clinic partner',
    city: 'Ontario',
    initials: 'CA',
    placeholder: true,
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="section-label">From the Clinic</p>
          <h2 className="mt-3 section-heading">What physicians are saying</h2>
          <p className="section-sub">
            Used daily by physicians across Ontario.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              className="relative rounded-2xl bg-white border border-gray-200 shadow-sm p-7 flex flex-col"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
            >
              {/* Quote mark */}
              <svg className="h-7 w-7 text-primary-200 mb-4 flex-shrink-0" fill="currentColor" viewBox="0 0 32 32">
                <path d="M10 8C6.686 8 4 10.686 4 14v10h10V14H7.5C7.5 11.515 9.015 10 11.5 10L10 8zm14 0c-3.314 0-6 2.686-6 6v10h10V14h-6.5C21.5 11.515 23.015 10 25.5 10L24 8z" />
              </svg>

              <p className="text-sm leading-relaxed flex-1 text-gray-500 italic">
                {t.quote}
              </p>

              <div className="mt-6 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 bg-gray-100 text-gray-400">
                  {t.initials}
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-500">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.title} · {t.city}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Partner logos are shown in PartnerMarquee below — no duplicate row here */}
      </div>
    </section>
  );
}
